var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 100C200 44.7715 155.229 0 100 0C44.7715 0 0 44.7715 0 100C0 149.912 36.5684 191.283 84.375 198.785V128.906H58.9844V100H84.375V77.9688C84.375 52.9063 99.3047 39.0625 122.146 39.0625C133.088 39.0625 144.531 41.0156 144.531 41.0156V65.625H131.922C119.5 65.625 115.625 73.334 115.625 81.2422V100H143.359L138.926 128.906H115.625V198.785C163.432 191.283 200 149.912 200 100Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook_logo.c4f27ea82cd5cc3006ce5d1ca4f44e68.svg";
export { ForwardRef as ReactComponent };